import { NgxFileDropModule } from 'ngx-file-drop';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DocumentModalComponent } from './document-modal/document-modal.component';
import { DocumentLoadComponent } from './document-load/document-load.component';
import { DocumentsPurchaseComponent } from './summary/documents-purchase/documents-purchase.component';
import { VisualizationFormComponent } from './visualization-form/visualization-form.component';
import { DocumentsClientComponent } from './summary/documents-client/documents-client.component';
import { DocumentsBeneficiaryComponent } from './summary/documents-beneficiary/documents-beneficiary.component';
import { DocumentsPaymentsComponent } from './summary/documents-payments/documents-payments.component';
import { DocumentsRepresentantComponent } from './summary/documents-representant/documents-representant.component';
import { DocumentProceedingsModalComponent } from './document-proceedings-modal/document-proceedings-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DocumentProceedingsComponent } from './document-proceedings/document-proceedings.component';
import { DocumentPaymentModalComponent } from './document-payment-modal/document-payment-modal.component';
import { ValidationModule } from '../validation/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DirectivesModule } from '../../directives/directives.module';
import { DocumentIdentificationModalComponent } from './document-identification-modal/document-identification-modal.component';
import { DocumentBeneficiaryModalComponent } from './document-beneficiary-modal/document-beneficiary-modal.component';
import { RestrictionModalComponent } from './restriction-modal/restriction-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DocumentProofModalComponent } from './document-proof-modal/document-proof-modal.component';
import { AlertProofModalComponent } from './alert-proof-modal/alert-proof-modal.component';
import { ConfirmationDocModalComponent } from './confirmation-doc-modal/confirmation-doc-modal.component';
import { DocumentBillingPermissionModal } from './document-billing-permission-modal/document-billing-permission-modal.component';
import { DocumentOuputSheetModal } from './document-ouput-sheet-modal/document-output-sheet-modal.component';
import { GenericModule } from '../generic/generic.module';
import { InvoiceDocumentModalComponent } from './invoice-document-modal/invoice-document-modal.component';
import { DeleteOperationModal } from './delete-operation-modal/delete-operation-modal.component';
import { HomeCreditDocumentModalComponent } from './home-credit-document-modal/home-credit-document-modal.component';
import { DisbursementValidationModalComponent } from './disbursement-validation-modal/disbursement-validation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxFileDropModule,
    PdfViewerModule,
    ValidationModule,
    BsDatepickerModule,
    NgSelectModule,
    DirectivesModule,
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    GenericModule,
    
  ],
  declarations: [
    DocumentModalComponent,
    DocumentLoadComponent,
    DocumentsPurchaseComponent,
    VisualizationFormComponent,
    DocumentsClientComponent,
    DocumentsBeneficiaryComponent,
    DocumentsPaymentsComponent,
    DocumentsRepresentantComponent,
    DocumentProceedingsModalComponent,
    DocumentProceedingsComponent,
    DocumentPaymentModalComponent,
    DocumentIdentificationModalComponent,
    DocumentBeneficiaryModalComponent,
    RestrictionModalComponent,
    DocumentProofModalComponent,
    AlertProofModalComponent,
    ConfirmationDocModalComponent,
    DocumentBillingPermissionModal,
    DocumentOuputSheetModal,
    InvoiceDocumentModalComponent,
    DeleteOperationModal,
    HomeCreditDocumentModalComponent,
    DisbursementValidationModalComponent
  ],
  exports: [
    DocumentModalComponent,
    DocumentLoadComponent,
    DocumentsPurchaseComponent,
    VisualizationFormComponent,
    DocumentsBeneficiaryComponent,
    DocumentsPaymentsComponent,
    DocumentsClientComponent,
    DocumentsRepresentantComponent,
    DocumentProceedingsModalComponent,
    DocumentPaymentModalComponent,
    DocumentIdentificationModalComponent,
    DocumentBeneficiaryModalComponent,
    RestrictionModalComponent,
    DocumentProofModalComponent,
    AlertProofModalComponent,
    DocumentBillingPermissionModal,
    DocumentOuputSheetModal,
    InvoiceDocumentModalComponent,
    DeleteOperationModal,
    HomeCreditDocumentModalComponent,
    DisbursementValidationModalComponent
  ],
})
export class DocumentModule {}
